import Button from '@/common/components/Button'
import Modal from '@/common/components/Modal'
import { ModalMessageSimple } from '@/common/components/ModalMessageSimple'
import { FormTransformers } from '@/common/utils/formTransformers'
import { useDeleteGovernmentAllocationProductCategoryDistribution } from '@/features/governmentAllocations/hooks/useDeleteGovernmentAllocationProductCategoryDistribution'
import { useQueryClient } from '@tanstack/react-query'
import { Trash2Icon } from 'lucide-react'
import { useState } from 'react'

interface GovernmentAllocationProductCategoryDistributionDeleteModalProps {
  productCategoryDistributionId?: string
}

export const GovernmentAllocationProductCategoryDistributionDeleteModal = ({
  productCategoryDistributionId,
}: GovernmentAllocationProductCategoryDistributionDeleteModalProps) => {
  const queryClient = useQueryClient()

  const [isOpen, setIsOpen] = useState(false)
  const [messages, setMessages] = useState<string[] | boolean>(false)

  const onSuccess = () => {
    setIsOpen(false)
    queryClient.invalidateQueries({ queryKey: ['companyGovernmentAllocation'] })
    queryClient.invalidateQueries({ queryKey: ['governmentAllocationsDistributions'] })
    queryClient.invalidateQueries({ queryKey: ['governmentAllocationsBranchesToDistribute'] })
    queryClient.invalidateQueries({ queryKey: ['governmentAllocationsAllowedCategoriesAndProducts'] })
  }

  const { mutate: deleteProductCategoryDistribution, isPending: deleteProductCategoryDistributionIsPending } =
    useDeleteGovernmentAllocationProductCategoryDistribution({
      onSuccess,
      onError: (error) => {
        setIsOpen(false)
        FormTransformers.errorsTransformer({ setMessages })(error)
      },
    })

  return (
    <>
      <Modal
        Trigger={
          <Button
            type="button"
            variant="outline-error"
            className="size-10 p-0"
            operationKlassToCheckPermission="Client::Billing::GovernmentAllocationProductCategoryDistributions::Stale"
          >
            <Trash2Icon strokeWidth={1} />
          </Button>
        }
        triggerAsChild
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        title="Você tem certeza?"
        showClose={false}
        useCancellableFooter
        confirmButtonText="Remover categoria"
        disabled={deleteProductCategoryDistributionIsPending}
        confirmButtonIsLoading={deleteProductCategoryDistributionIsPending}
        onConfirm={() => deleteProductCategoryDistribution(productCategoryDistributionId)}
      />

      <ModalMessageSimple messages={messages} setMessages={setMessages} isError />
    </>
  )
}
